// Per-topic chip palette. `bg` is a translucent tint that works on either
// theme; `fg` needs a light variant, since the dark-mode card sits on a near
// black surface where the 800-weight text is unreadable.
export const TOPIC_COLORS = {
  technology:    { bg: "rgba(59, 130, 246, 0.14)",  fg: "#1e40af", fgDark: "#93c5fd" },
  business:      { bg: "rgba(168, 85, 247, 0.14)",  fg: "#6b21a8", fgDark: "#d8b4fe" },
  entertainment: { bg: "rgba(236, 72, 153, 0.14)",  fg: "#9d174d", fgDark: "#f9a8d4" },
  sports:        { bg: "rgba(34, 197, 94, 0.16)",   fg: "#15803d", fgDark: "#86efac" },
  science:       { bg: "rgba(14, 165, 233, 0.14)",  fg: "#075985", fgDark: "#7dd3fc" },
  health:        { bg: "rgba(16, 185, 129, 0.14)",  fg: "#065f46", fgDark: "#6ee7b7" },
  world:         { bg: "rgba(99, 102, 241, 0.14)",  fg: "#3730a3", fgDark: "#a5b4fc" },
  nation:        { bg: "rgba(234, 88, 12, 0.14)",   fg: "#9a3412", fgDark: "#fdba74" },
  default:       { bg: "rgba(120, 120, 120, 0.14)", fg: "#374151", fgDark: "#d1d5db" },
};

export function topicColor(topic, mode = "light") {
  const c = TOPIC_COLORS[String(topic || "").toLowerCase()] || TOPIC_COLORS.default;
  return { bg: c.bg, fg: mode === "dark" ? c.fgDark : c.fg };
}

// Three bands, because a 1-10 number the eye has to read is not a signal.
// Only the top band is loud — if everything glows, nothing does.
export const HEAT_BANDS = {
  hot:  { bg: "rgba(239, 68, 68, 0.16)",  fg: "#b91c1c", fgDark: "#fca5a5" },
  warm: { bg: "rgba(245, 158, 11, 0.16)", fg: "#b45309", fgDark: "#fcd34d" },
  cool: { bg: "rgba(120, 120, 120, 0.12)", fg: "#4b5563", fgDark: "#cbd5e1" },
};

export const heatBand = (score) =>
  score >= 8 ? "hot" : score >= 6 ? "warm" : "cool";

export function heatColor(score, mode = "light") {
  const c = HEAT_BANDS[heatBand(score)];
  return { bg: c.bg, fg: mode === "dark" ? c.fgDark : c.fg };
}

// "Article ready" — deliberately not a heat band, so done never reads as alarm.
export const doneColor = (mode = "light") => ({
  bg: "rgba(16, 185, 129, 0.16)",
  fg: mode === "dark" ? "#6ee7b7" : "#047857",
});

// A job that died. The one place on this card where alarm is the right read.
export const failColor = (mode = "light") => ({
  bg: "rgba(239, 68, 68, 0.16)",
  fg: mode === "dark" ? "#fca5a5" : "#b91c1c",
});
